import { render, staticRenderFns } from "./index--echarts-three.vue?vue&type=template&id=20ace533&scoped=true&"
import script from "./index--echarts-three.vue?vue&type=script&lang=js&"
export * from "./index--echarts-three.vue?vue&type=script&lang=js&"
import style0 from "./index--echarts-three.vue?vue&type=style&index=0&id=20ace533&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ace533",
  null
  
)

export default component.exports